import * as React from "react";
import clsx from "clsx";
import { FormInput, FormInputProps } from "fe-web-components/layout/formInput";

//region [[ Styles ]]
//endregion [[ Styles ]]

//region [[ Props ]]

export interface ClinicFormInputProps extends FormInputProps {}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const ClinicFormInput = ({ ...props }: ClinicFormInputProps) => {
  return (
    <FormInput
      className={clsx(props.className, "clinic-form-input")}
      {...props}
    />
  );
};
